// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2f32d","content":"styles_content__3EX35","tableWrap":"styles_tableWrap__2AcPs"};